// ***** Library Imports *****
import { Route, Routes } from "react-router-dom";

import HomePage from "@/app/(public)/page";
import LoginLayout from "@/app/(public)/login/layout";
import AdminLoginPage from "@/app/(public)/login/admin/page";
import EmployeeLoginPage from "@/app/(public)/login/employee/page";
import SuperAdminLoginPage from "@/app/(public)/login/super-admin/page";
import TeamLeaderLoginPage from "@/app/(public)/login/team-leader/page";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route element={<LoginLayout />}>
        <Route path="/login/admin" element={<AdminLoginPage />} />
        <Route path="/login/employee" element={<EmployeeLoginPage />} />
        <Route path="/login/superadmin" element={<SuperAdminLoginPage />} />
        <Route path="/login/teamleader" element={<TeamLeaderLoginPage />} />
      </Route>
    </Routes>
  );
};

export default PublicRoutes;
